module.exports = __webpack_public_path__ + "static/media/plugInversor.7b131dd1.png";